
export const SEARCH_STATE_IDS = {
  NARRATIVES: "narratives",
  MEDIA: "media",
  CONNECTOR: "dataConnector",
  EXPLORER: "dataExplorer",
  COMPARE_LEFT: "compareLeft",
  COMPARE_RIGHT: "compareRight",
  SOCIAL_MEDIA: "social",
  WEB_PAGES: "webPages",
}


export const getCompareStateId = (side) => {
	return side === "Left" ? SEARCH_STATE_IDS.COMPARE_LEFT : SEARCH_STATE_IDS.COMPARE_RIGHT;
}